import { render, staticRenderFns } from "./Finace_Dzgl.vue?vue&type=template&id=23788ff9&"
import script from "./Finace_Dzgl.vue?vue&type=script&lang=js&"
export * from "./Finace_Dzgl.vue?vue&type=script&lang=js&"
import style0 from "./Finace_Dzgl.vue?vue&type=style&index=0&id=23788ff9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports